export enum UserHasQualificationStatusEnum {
  IN_MANAGEMENT = "IN_MANAGEMENT",
  FINISHED = "FINISHED",
  NOT_COMPLETED = "NOT_COMPLETED",
}

export const getUserHasQualificationStatusLabel = (status: UserHasQualificationStatusEnum): string => {
  switch (status) {
    case UserHasQualificationStatusEnum.IN_MANAGEMENT:
      return "En gestión";
    case UserHasQualificationStatusEnum.FINISHED:
      return "Finalizado";
    case UserHasQualificationStatusEnum.NOT_COMPLETED:
      return "Sin realizar";
  }
};

export const getUserHasQualificationStatusOptions = (): { value: UserHasQualificationStatusEnum; label: string }[] => {
  const keys = Object.keys(UserHasQualificationStatusEnum).filter(
    (key: string) => typeof UserHasQualificationStatusEnum[key as keyof typeof UserHasQualificationStatusEnum] === "string",
  );
  return keys.map((val) => {
    const value = UserHasQualificationStatusEnum[val as keyof typeof UserHasQualificationStatusEnum];
    return { label: getUserHasQualificationStatusLabel(value), value };
  });
};
